import { useAsyncExecutor } from "async-executor-hook";
import { FC, useState } from "react";

import { HTTP_METHODS, ImportFlowScreens } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import Steps from "../Steps/Steps";
import {
  DivHeader,
  H1Header,
  MainContainer,
} from "./UsersManagementAdminStyles";
import UsersManagementStepOneAdminForm from "./UsersManagementStepOneAdminForm";
import UsersManagementStepTwoAdminForm from "./UsersManagementStepTwoAdminForm";

const STEPS = [
  {
    description: "Datos de la empresa",
    screenName: ImportFlowScreens.COMPANY_DATA,
  },
  {
    description: "Datos del usuario",
    screenName: ImportFlowScreens.USER_DATA,
  },
];
interface ICompany {
  ruc?: string;
  name?: string;
  address?: string;
  phone_number?: string;
  sunarp_number?: string;
  email?: string;
  contact_name?: string;
  contact_phone_number?: string;
}
interface Iprofile {
  id?: string;
  name?: string;
}
interface Irole {
  name?: string;
  id?: string;
  profile?: Iprofile;
}
interface IUserEditPlain {
  company?: ICompany;
  full_name?: string;
  document_type?: string;
  document_number?: string;
  phone_number?: string;
  email?: string;
  job?: string;
  role?: Irole;
  processes?: [];
}
interface IUsersManagementStepAdmin {
  toggleModal: () => void;
  dataUserEditAdmin: IUserEditPlain;
  setShowModalSuccessRegister: any;
  setMessageSuccessRegister: any;
  setTitleMessageUsers: any;
  userProfileMe: {
    role?: Irole;
  };
}
const UsersManagementStepAdmin: FC<IUsersManagementStepAdmin> = (props) => {
  const {
    toggleModal,
    dataUserEditAdmin,
    setShowModalSuccessRegister,
    setMessageSuccessRegister,
    setTitleMessageUsers,
    userProfileMe,
  } = props;
  const [screen, setScreen] = useState(ImportFlowScreens.COMPANY_DATA);
  const stepTwoActivate = (step) => {
    setScreen(step);
  };

  const [checkInput, setCheckInput] = useState(
    dataUserEditAdmin ? true : false
  );
  const [valueInputCheck, setValueInputCheck] = useState(
    dataUserEditAdmin ? dataUserEditAdmin.company.ruc : ""
  );
  const [errorLine, setErrorLine] = useState(false);

  const loadRuc = useAsyncExecutor(
    (params: any) => {
      const { valueInputCheck } = params;
      const rucValue = valueInputCheck;
      return networkBackendRequest(
        `/agencies/${rucValue}/`,
        HTTP_METHODS.GET,
        {}
      ).then((response) => response.json());
    },
    {
      onSuccess: (params) => {
        setErrorLine(false);
      },
      onError: () => {
        setErrorLine(true);
        setCheckInput(false);
      },
    }
  );

  const handleChange = (event) => {
    event.preventDefault();
    setValueInputCheck(event.target.value);
  };

  const loadRucSuccess = loadRuc.isSuccess && loadRuc.data;

  const [dataInitialCompany, setDataInitialCompany] = useState({
    ruc: dataUserEditAdmin ? dataUserEditAdmin.company.ruc : "",
    name: dataUserEditAdmin ? dataUserEditAdmin.company.name : "",
    address: dataUserEditAdmin ? dataUserEditAdmin.company.address : "",
    phone_number: dataUserEditAdmin
      ? dataUserEditAdmin.company.phone_number
      : "",
    sunarp_number: dataUserEditAdmin
      ? dataUserEditAdmin.company.sunarp_number
      : "",
    email: dataUserEditAdmin ? dataUserEditAdmin.company.email : "",
    contact_name: dataUserEditAdmin
      ? dataUserEditAdmin.company.contact_name
      : "",
    contact_phone_number: dataUserEditAdmin
      ? dataUserEditAdmin.company.contact_phone_number
      : "",
  });

  const [dataInitialUsers, setDataInitialUsers] = useState({
    full_name: dataUserEditAdmin ? dataUserEditAdmin.full_name : "",
    document_type: dataUserEditAdmin ? dataUserEditAdmin.document_type : "dni",
    document_number: dataUserEditAdmin ? dataUserEditAdmin.document_number : "",
    phone_number: dataUserEditAdmin ? dataUserEditAdmin.phone_number : "",
    email: dataUserEditAdmin ? dataUserEditAdmin.email : "",
    job: dataUserEditAdmin ? dataUserEditAdmin.job : "",
    authorization_doc: dataUserEditAdmin ? dataUserEditAdmin.role.name : "",
    role: dataUserEditAdmin
      ? {
          name: dataUserEditAdmin ? dataUserEditAdmin.role.name : "",
          id: dataUserEditAdmin ? dataUserEditAdmin.role.id : "",
          profile: {
            id: dataUserEditAdmin ? dataUserEditAdmin.role.profile.id : "",
            name: dataUserEditAdmin ? dataUserEditAdmin.role.profile.name : "",
          },
        }
      : "",
    profile_id: dataUserEditAdmin
      ? dataUserEditAdmin.role.id
      : userProfileMe.role.id,
    processes: dataUserEditAdmin
      ? dataUserEditAdmin.processes
      : [
          {
            process_name: "myprocess",
          },
        ],
  });
  const [makeEnabled, setMakeEnabled] = useState(true);

  return (
    <>
      <DivHeader dataUser={dataUserEditAdmin ? true : false}>
        <div className="margin-top-left-position">
          <H1Header>
            {dataUserEditAdmin ? "Editar usuario" : "Crear usuario"}
          </H1Header>
          <div className="font-weight-color">
            {dataUserEditAdmin && dataUserEditAdmin.full_name}
          </div>
        </div>
        <Steps
          currentScreenName={screen}
          updateScreen={setScreen}
          stepsInfo={STEPS}
          makeDisable={makeEnabled}
        />
      </DivHeader>
      <MainContainer>
        {screen === ImportFlowScreens.COMPANY_DATA ? (
          <UsersManagementStepOneAdminForm
            dataInitialCompany={dataInitialCompany}
            onSuccess={(data) => {
              stepTwoActivate(ImportFlowScreens.USER_DATA);
              setDataInitialCompany(data);
              setMakeEnabled(false);
            }}
            setCheckInput={setCheckInput}
            checkInput={checkInput}
            valueInputCheck={valueInputCheck}
            errorLine={errorLine}
            handleChange={handleChange}
            loadRuc={loadRuc}
            dataUserEditAdmin={dataUserEditAdmin}
          />
        ) : screen === ImportFlowScreens.USER_DATA ? (
          <UsersManagementStepTwoAdminForm
            dataInitialCompany={dataInitialCompany}
            dataInitialUsers={dataInitialUsers}
            toggleModal={toggleModal}
            dataUserEditAdmin={dataUserEditAdmin}
            loadRucSuccess={loadRucSuccess}
            setShowModalSuccessRegister={setShowModalSuccessRegister}
            setMessageSuccessRegister={setMessageSuccessRegister}
            setTitleMessageUsers={setTitleMessageUsers}
            setDataInitialCompany={setDataInitialCompany}
            setDataInitialUsers={setDataInitialUsers}
          />
        ) : null}
      </MainContainer>
    </>
  );
};

export default UsersManagementStepAdmin;
